import React from "react";
import classes from "./formTextArea.module.css";

export const FormTextArea = ({
  id,
  placeholder = " ", // IMPORTANT for floating label
  label,
  register,
  disabled,
  validation,
  defaultValue,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.inputBox}>
        <textarea
          id={id}
          className={classes.input}
          placeholder={placeholder}
          {...register(id, validation)}
          defaultValue={defaultValue}
          disabled={disabled}
        />

        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
        </label>
      </div>
    </div>
  );
};
